const getClassYearsFilter = response => {
  const formattedData = response.data.map(year => ({
    id: year.toString(),
    name: year.toString(),
  }));

  return {
    key: 'classYears',
    source: 'classYears',
    filterName: 'Class Years',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getClassYearsFilter;
